import AdminPanel from "./AdminPanel.component";

export default AdminPanel;
